var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeakerNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "speaker_normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2693",
    "data-name": "\\u9577\\u65B9\\u5F62 2693",
    width: 20,
    height: 15.486,
    fill: "#666"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Play",
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1687",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1687",
    transform: "translate(-3 -1.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1275",
    "data-name": "\\u30D1\\u30B9 1275",
    d: "M4.667,4.438H0v6.567H4.667l4.387,4.378V.06Z",
    transform: "translate(0 0.022)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1685",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1685",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1684",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1276",
    "data-name": "\\u30D1\\u30B9 1276",
    d: "M8.21,4.327a3.062,3.062,0,0,1,0,4.347l.927.929a4.371,4.371,0,0,0,0-6.205Z",
    transform: "translate(3.004 1.242)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1277",
    "data-name": "\\u30D1\\u30B9 1277",
    d: "M10.837,1.7l-.929.929a6.336,6.336,0,0,1,0,8.989l.929.927a7.647,7.647,0,0,0,0-10.845",
    transform: "translate(3.625 0.621)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1278",
    "data-name": "\\u30D1\\u30B9 1278",
    d: "M12.536,0l-.929.929a9.614,9.614,0,0,1,0,13.63l.929.929A10.929,10.929,0,0,0,12.536,0",
    transform: "translate(4.246 -0.001)",
    fill: "#666"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2694",
    "data-name": "\\u9577\\u65B9\\u5F62 2694",
    width: 24,
    height: 24,
    transform: "translate(-5 -6)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2695",
    "data-name": "\\u9577\\u65B9\\u5F62 2695",
    width: 20,
    height: 20,
    transform: "translate(-3 -4)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerNormal);
export default __webpack_public_path__ + "static/media/speaker_normal.85ce4b2331606dd09a2b99425daddedf.svg";
export { ForwardRef as ReactComponent };